import type {
  IFileBasedExamDto,
  IFileBasedExamGetAllParams,
  IFileBasedExamResponse,
} from "./types";
import type { IPathBaseParam, IPathByIdParam } from "./path";

import type { IApiResponse, IPagination, IPaginationParams } from "@/api";
import { createGetAllApi } from "@api/util/createGetAllApi";
import { createPostApi } from "@api/util/createPostApi";
import { createGetApi } from "@api/util/createGetApi";
import { createDeleteApi } from "@api/util/createDeleteApi";
import { createPatchApi } from "@api/util/createPatchApi";
import type { ICourseResponse } from "@api/courses/types";
import { grades } from "@api/courses/exams/fileBased/grades/api";
import { attempt } from "@api/courses/exams/fileBased/attempts/api";

const getAllApis = createGetAllApi<
  IApiResponse<
    IPagination<IFileBasedExamResponse, { course: ICourseResponse }> & {
      metadata: {
        active_exams_count: number;
        taken_exams_count: number;
        untaken_exams_count: number;
      };
    }
  >,
  IPathBaseParam,
  IPaginationParams & IFileBasedExamGetAllParams
>("courses.exams.fileBased");
const postApis = createPostApi<
  IApiResponse<IFileBasedExamResponse>,
  IPathBaseParam,
  IFileBasedExamDto
>("courses.exams.fileBased");
const getApis = createGetApi<
  IApiResponse<IFileBasedExamResponse>,
  IPathByIdParam,
  object
>("courses.exams.fileBased");
const patchApis = createPatchApi<
  IApiResponse<IFileBasedExamResponse>,
  IPathByIdParam,
  IFileBasedExamDto
>("courses.exams.fileBased");
const deleteApis = createDeleteApi<
  IApiResponse<IFileBasedExamResponse>,
  IPathByIdParam
>("courses.exams.fileBased");

export const fileBased = {
  ...getAllApis,
  ...getApis,
  ...postApis,
  ...patchApis,
  ...deleteApis,
  grades,
  attempt,
};
